import icon from '../../assets/svg/数据分析.svg';
import type { RouteConfig } from '@/types/route';

export const routeConfig: RouteConfig = {
    title: 'route.dataAnalysis',
    icon:  <img src={icon} alt="Data Analysis" className="w-4 h-4" />,
    layout: true,
    sort: 1
};